import React from "react"

import Parameters from "~components/Parameters"

const ParamGroup = ({
  params, explorer, microcopy, location,
}) => (
  <>
    {params?.[0] && (
      <>
        <h3 id={`${location}-parameters`}>
          <a href={`#${location}-parameters`} data-display-anchor>
            {microcopy.text(`reference.parameter_groups.${location}`)}
          </a>
        </h3>
        <Parameters params={params} explorer={explorer} location={location} />
      </>
    )}
  </>
)

export default ParamGroup
